import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import type { LinesOnSiteStop } from '../../helpers/assignmentOrderStops'

/** Power-lines-on-site warning for every stop of the assignment. */
export const LinesOnSiteBlock = ({ stops }: { stops: LinesOnSiteStop[] }) => {
  const { _ } = useLingui()
  if (stops.length === 0) return null

  const stopLabel = ({ stopNumber, siteName }: LinesOnSiteStop) => {
    if (siteName) {
      return _(msg`Stop #${stopNumber} at ${siteName} has lines on site`)
    }
    return _(msg`Stop #${stopNumber} has lines on site`)
  }

  return (
    <div className='assignment-detail__hero-block'>
      <div className='assignment-detail__section-title assignment-detail__section-title--warning'>
        {_(msg`Lines on Site`)}
      </div>
      <div className='assignment-detail__section-body'>
        {stops.map((stop) => (
          <div key={stop.stopNumber}>{stopLabel(stop)}</div>
        ))}
      </div>
    </div>
  )
}
